<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  large: { type: Boolean, default: false },
});
</script>

<template>
  <div class="flex flex-col">
    <span class="text-[10px] uppercase tracking-wide text-n-slate-9">
      {{ label }}
    </span>
    <span
      class="font-bold text-n-slate-12"
      :class="large ? 'text-lg' : 'text-sm'"
    >
      {{ value }}
    </span>
  </div>
</template>
